<template>
    <div>
        <h4>{{ name }}</h4>
        <h1>{{ value }}</h1>
    </div>
</template>

<script>
export default {
    props: ['name', 'value']
}
</script>

<style scoped>
div {
    display: flex;
    flex-direction: column;
    border: solid 1px #838391;
    height: 128px;
    padding: 20px 23px;
    vertical-align: middle;
    width: 255px;
}

h1 {
    font-size: 40px;
    line-height: 52px;
    letter-spacing: -1.5px;
    margin: 0;
}

h4 {
    font-family: "Spartan", sans-serif;
    font-size: 11px;
    font-weight: bold;
    color: #838391;
    line-height: 25px;
    letter-spacing: 1px;
    margin:0;
}

@media screen and (max-width: 1199px){
    h4 {
        font-size: 8px;
        line-height: 16px;
        letter-spacing: 0.73px;
    }
}

@media screen and (max-width: 767px) {
    div {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 48px;
        padding: 11px 24px;
        width: 327px;
    }

    h1 {
        font-size: 20px;
        letter-spacing: -0.75px;
    }
}

@media screen and (min-width: 768px) and (max-width: 1199px){
    div {
        height: 88px;
        width: 164px;
        padding-top: 17px;
    }

    h1 {
        font-size: 24px;
        letter-spacing: -0.9px;
    }
    
}

</style>